module.exports = __webpack_public_path__ + "img/default.f15ae220.png";